import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ICallableObject } from '@df/api/request/request.service';
import { Login } from '@df/session/login/login.interfaces';
import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Nexus } from '@tomandco/nexus-api-types';
import isArray from 'lodash-es/isArray';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../../ui/form/mui-input.directive';

@Component({
    selector: 'login-reset-password',
    templateUrl: 'login-reset-password.html',
    standalone: true,
    imports: [ActionComponent, FormsModule, InputWrapBodyDirective, InputWrapComponent, MuiInputDirective, ResultComponent, TranslatePipe]
})
export class LoginResetPasswordComponent<T = Login.IResetPasswordWithTokenFormData> extends AbstractFormComponent<T> {
    /**
     * Submission path
     */
    protected submitPath = Nexus.Api.Customer.ApplyPasswordReset.path;

    constructor(
        protected activatedRoute: ActivatedRoute,
        ref: ChangeDetectorRef
    ) {
        super(ref);
    }

    /**
     * Submission action prepation to inject query params
     */
    protected override getSubmitAction(): ICallableObject<Partial<T>> {
        const queryMap = this.activatedRoute.snapshot.queryParamMap;
        const token = queryMap.get('token');
        const id = queryMap.get('id');

        return {
            path: this.submitPath,
            data: <T>{
                ...this.data,
                token: token ? (isArray(token) ? token[token.length - 1] : token) : '****',
                id: id || '****'
            }
        };
    }
}
